import { useCallback } from "react";

export const useFormatAmount = () => {
  return useCallback((amount: string | number): string => {
    const num = parseFloat(amount.toString());
    if (isNaN(num)) return "0.00";
    return (Math.round(num * 100) / 100).toFixed(2);
  }, []);
};
